import axios from 'axios';

const cnpjApi = axios.create({
  baseURL: 'https://consulta-cnpj-gratis.p.rapidapi.com/companies/',
  headers: {'x-rapidapi-key': 'c472a69594mshccc85e929f3cf5ep1b15a0jsn78b03be58fd0'}
});

export default cnpjApi;
